<template>
  <el-select
    v-model="tenant_id"
    class="tenantSelect"
    filterable
    :disabled="disabled"
    :placeholder="placeholder"
    @change="change()"
  >
    <el-option
      v-for="tenant in tenants"
      :key="tenant.id"
      :label="`${tenant.first_name} ${tenant.last_name}`"
      :value="tenant.id"
    >
      {{ tenant.first_name }} {{ tenant.last_name }}
    </el-option>
  </el-select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "TenantSelect",
  props: {
    value: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    change: {
      type: Function,
      default: () => { }
    }
  },
  data: () => ({
    tenants: []
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord
    }),
    tenant_id: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  async mounted() {
    if (this.currentRecord) {
      // filter tenant not already in records
      this.tenants = (await this.$api.recordsPeople.getTenants()).filter(tenant => {
        return !this.currentRecord.tenant_ids.includes(tenant.id)
      })
    } else {
      // new record
      this.tenants = await this.$api.recordsPeople.getTenants()
    }
  }
}
</script>

<style lang="scss" scoped>
$c: ".tenantSelect";

#{$c} {
}
</style>